import React, { useEffect, useRef, useState } from "react";
import { keycloak } from "../../../lib/keycloak/index";
import { findAvatarByObjectId, setFindDocumentStatus } from "../../../lib/object/slice";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook";
import { colors } from "../../colors";
import { LogoutIcon } from "../../icons/logoutIcon";
import { NotificationIcon } from "../../icons/notificationIcon";
import { SupportIcon } from "../../icons/supportIcon";
import Avatar from "../../molecules/avatar/index";
import { SpinnerComponent } from "../../molecules/spinner/index";

export function HeaderComponent() {
    const menuRef = useRef<HTMLTableCellElement>(null);

    const authState = useAppSelector(state => state.auth)
    const objectState = useAppSelector(state => state.object)
    const layuotState = useAppSelector(state => state.layout)
    const dispatch = useAppDispatch()

    const [showMenu, setShowMenu] = useState(false)
    const [altTextInitials, setAltTextInitials] = useState<string>("")
    const [name, setName] = useState<string>("")
    const [avatarToBase64, setAvatarToBase64] = useState("")
    const [isHover, setIsHover] = useState(false)

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const closeMenu = () => {
        setShowMenu(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            closeMenu();
        }
    };

    useEffect(() => {
        if (showMenu) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showMenu]);

    useEffect(() => {
        switch (authState.findMeUserResponse?.id) {
            case 0:
                setAltTextInitials('AD')
                break;
            default: setName(authState.findMeUserResponse?.name + " " + authState.findMeUserResponse?.surname)
                setAltTextInitials((authState.findMeUserResponse?.name[0] || '') + (authState.findMeUserResponse?.surname[0] || ''))
                break;
        }
    }, [authState.findMeUserResponse]);

    return (
        <div className="flex flex-row gap-[16px] items-center">
            <div className="cursor-pointer relative flex items-center gap-1.5"
                onClick={e => { toggleMenu() }}
                ref={menuRef}>
                <span className="text-text-sm font-semibold text-neutral-800">
                    {authState.findMeUserResponse?.id === 0 ? 'Amministratore' : authState.findMeUserResponse?.name + " " + authState.findMeUserResponse?.surname}
                </span>
                <div>
                    <Avatar type="single" size="md" shape="circle" imageUrl={avatarToBase64} altTextInitials={altTextInitials} />
                    {
                        showMenu &&
                        <div
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (localStorage.getItem('popup') !== null)
                                    localStorage.removeItem('popup')
                                keycloak.logout();
                            }}
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            style={{
                                backgroundColor: isHover ? '#B29CFE' : colors.white
                            }}
                            className={"absolute right-2 shadow-sm rounded-xl p-3 gap-2 flex items-center w-[200px]"}
                        >
                            <LogoutIcon color={!isHover ? colors.neutral[500] : '#6237fb'} />
                            <span
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)}
                                style={{
                                    color: isHover ? '#6237fb' : colors.neutral[600]
                                }}
                                className={"text-text-md font-semibold"}
                            >
                                Esci
                            </span>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}